export default "__VITE_ASSET__DfDWHZtr__"